/**
 * AdminRoute.js
 * Route wrapper that restricts access to admin users only
 *
 * Usage:
 * <Route path="/admin-feature" element={
 *   <AdminRoute>
 *     <AdminFeaturePage />
 *   </AdminRoute>
 * } />
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * PHIL FEATURE: Admin-only access during redesign (January 2026)
 *
 * This route wrapper restricts access to admin users only.
 * Phil is temporarily restricted while we redesign the feature.
 * Phil 2.0 will integrate with AI Explorer's synthesis capabilities
 * and improve conversation quality, recall system, and cluster detection.
 *
 * This restriction will be removed when Phil 2.0 launches.
 */
const AdminRoute = ({ children }) => {
  const { user, isLoading } = useAuth();

  // Wait for auth to load before making routing decisions
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        Loading...
      </div>
    );
  }

  // Redirect non-admins to dashboard
  if (!user?.isAdmin) {
    return <Navigate to="/my-knowledge-entries" replace />;
  }

  // User is admin - render the protected component
  return children;
};

export default AdminRoute;
